import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { P2 } from '../../../../components/Typographies/Paragraph';
import { H2 } from '../../../../components/Typographies/Title';
import Accordion from './Accordion';
import { homePageFAQMessages } from './messages';

const Container = styled.div`
  ${tw`relative pt-medium2`}

  @media (min-width: 992px) {
    &:before {
      z-index: -1;
      content: ' ';
      position: absolute;
      background: radial-gradient(
        43.16% 43.16% at 50% 50%,
        rgba(34, 227, 170, 0.15) 0%,
        rgba(215, 243, 229, 0) 100%
      );
      width: 579.2109365188024px;
      left: -348px;
      top: -493px;
      border-radius: 0px;
      bottom: 0;
      transform: rotate(329deg);
    }
  }
`;

const Wrapper = styled.div`
  ${tw`mt-medium2 flex flex-col mx-auto`}
  gap: var(--size-small);
  max-width: 1000px;
`;

const Title = styled(H2)`
  ${tw`mx-auto`}
  width:max-content;
`;

const FAQ = () => (
  <Container>
    <Title>FAQ</Title>
    <Wrapper>
      {[1, 2, 3, 4, 5, 6].map((index) => (
        <Accordion
          key={index}
          header={
            <FormattedMessage {...homePageFAQMessages[`faqHeader${index}`]} />
          }
          index={index}
        >
          <P2>
            <FormattedMessage {...homePageFAQMessages[`faq${index}`]} />
          </P2>
        </Accordion>
      ))}
    </Wrapper>
  </Container>
);

export default FAQ;
